import React, { useContext, useState } from 'react';
import { useTheme } from '@emotion/react';
import { AgendaContext } from '../../../contexts/AgendaContext';
// Mui components
import { Box, Button, Typography } from '@mui/material';
// Components
import SmallModalContainer from '../../common/SmallModalContainer';
import DotLoader from '../../common/Loaders/DotLoader/DotLoader';

function ModalConfirmacionEnvio({ openModals, onHandleClose, modales, setOpenModals }) {
    const theme = useTheme();
    const [isLoading, setIsLoading] = useState(false)

    const { postSolicitud, solicitudProps, setUseBlockerOK, proveedorSeleccionado } = useContext(AgendaContext);

    const { direccionExterno, direccionOsde } = solicitudProps;

    const direccionExternoArray = direccionExterno.split(',');
    const direccionExternoFormateada = [...new Set(direccionExternoArray)].join(', ');

    const direccionOsdeArray = direccionOsde.split(',');
    const direccionOsdeFormateada = [...new Set(direccionOsdeArray)].join(', ');

    const handleConfirmar = async (event) => {
        event.preventDefault();
        setIsLoading(true)
        try {
            await postSolicitud(solicitudProps);
            setUseBlockerOK(false);
            setOpenModals({ ...modales, "successPost": true });
        } catch (error) {
            setUseBlockerOK(false);
            setOpenModals({ ...modales, "errorPost": true });
        } finally {
            setIsLoading(false)
        }

    };


    return (
        <SmallModalContainer
            open={openModals}
            onClose={onHandleClose}
        >
            <Box display="flex" flexDirection="column" gap={"1rem"}>
                <Typography variant="h2">¿Querés enviar esta solicitud?</Typography>
                <Typography variant="h5" component="p">Estás solicitando conectar las agendas de:</Typography>

                <Box sx={{ marginTop: ".5rem", padding: "1rem", borderRadius: "16px", border: `2px solid ${theme.palette.backgroundSecondary.main}` }}>
                    <Typography variant="bodyS" color={theme.palette.gray.main}>Consultorio publicado en: <Typography component="span" variant="boldBodyS" color={theme.palette.black.main}>{proveedorSeleccionado.label}</Typography></Typography>

                    <Typography variant="h5" component="p">{direccionExternoFormateada}</Typography>
                </Box>

                <Box sx={{ padding: "1rem", borderRadius: "16px", border: `2px solid ${theme.palette.backgroundSecondary.main}` }}>
                    <Typography variant="bodyS" color={theme.palette.gray.main}>Consultorio publicado en: <Typography component="span" variant="boldBodyS" color={theme.palette.black.main}>OSDE</Typography></Typography>

                    <Typography variant="h5" component="p">{direccionOsdeFormateada}</Typography>
                </Box>

                <Box display="flex" gap={"1rem"} marginTop="1.5rem">
                    <Button
                        onClick={onHandleClose}
                        disabled={isLoading}
                        variant="outlined"
                        sx={{ height: "48px", borderRadius: "16px", borderWidth: "2px", width: "50%" }}>
                        <Typography variant="cta" component="span">
                            Mejor no
                        </Typography>

                    </Button>
                    <Button
                        onClick={handleConfirmar}
                        variant="contained"
                        disabled={isLoading}
                        sx={{ height: "48px", borderRadius: "16px", width: "50%",
                             '&.Mui-disabled': {
                            backgroundColor: isLoading
                            ? theme.palette.darkBlue.main
                            : theme.palette.primary.main
                            } }}>
                        <Typography variant="cta" component="span"
                        >Enviar
                        </Typography>
                        {isLoading && <Box sx={{ position: "absolute", right: "1rem" }}><DotLoader size="7px" /></Box>}
                    </Button>

                </Box>
            </Box>
        </SmallModalContainer>
    );
}

export default ModalConfirmacionEnvio;